enum OfferType {
  STANDART = 'standart',
  DARK = 'dark',
}

export { OfferType }
